var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancelRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99609 18.6758C14.9795 18.6758 19.0928 14.5625 19.0928 9.58789C19.0928 4.61328 14.9707 0.5 9.9873 0.5C5.0127 0.5 0.908203 4.61328 0.908203 9.58789C0.908203 14.5625 5.02148 18.6758 9.99609 18.6758ZM6.99902 13.4199C6.5332 13.4199 6.16406 13.0508 6.16406 12.5762C6.16406 12.3652 6.25195 12.1543 6.41895 11.9961L8.80957 9.59668L6.41895 7.20605C6.25195 7.04785 6.16406 6.83691 6.16406 6.62598C6.16406 6.15137 6.5332 5.79102 6.99902 5.79102C7.24512 5.79102 7.43848 5.87012 7.59668 6.02832L9.99609 8.41895L12.4043 6.01953C12.5801 5.85254 12.7646 5.77344 13.002 5.77344C13.4678 5.77344 13.8369 6.14258 13.8369 6.6084C13.8369 6.82812 13.749 7.02148 13.582 7.19727L11.1914 9.59668L13.582 11.9873C13.7402 12.1543 13.8281 12.3564 13.8281 12.5762C13.8281 13.0508 13.459 13.4199 12.9844 13.4199C12.7471 13.4199 12.5449 13.332 12.3779 13.1738L9.99609 10.792L7.61426 13.1738C7.45605 13.3408 7.24512 13.4199 6.99902 13.4199Z",
    fill: "#D22626"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelRed);
export default __webpack_public_path__ + "static/media/cancel-red.ba8323e00fe2966212f4c87fa48bc052.svg";
export { ForwardRef as ReactComponent };